import { gql } from '@apollo/client';

export const GET_COURSES_EXIST_INFO = gql`
  query GetCoursesExistInfo {
    listCoursesLogedOut {
      id
      name
      navigation_description
      slug
    }
  }
`;

export const GET_COURSES_PROGRESS_INFO = gql`
  query GetCoursesProgressInfo {
    listCoursesLogedIn {
      id
      status
    }
  }
`;

export const GET_LIST_COURSES_LOGGED_OUT = gql`
  query GetListCoursesLoggedOut {
    listCoursesLogedOut {
      id
      name
      slug
      description
      image_url
      svg_icon
      general_info {
        pathways
        learning_hours
        cpd_credits
        experts
      }
    }
  }
`;

export const GET_LIST_COURSES_LOGGED_IN = gql`
  query GetListCoursesLoggedIn {
    listCoursesLogedIn {
      id
      status
      name
      slug
      description
      image_url
      svg_icon
      general_info {
        pathways
        learning_hours
        cpd_credits
        experts
      }
      progress
    }
  }
`;

export const GET_COURSE = gql`
  query GetCourse($filter: CourseSearchFilter) {
    getCourse(filter: $filter) {
      id
      name
      slug
      description
      image_url
      svg_icon
      intro_verse_video_id
      general_info {
        pathways
        learning_hours
        cpd_credits
        videos
        experts
      }
      usp_blocks {
        image
        label_text
      }
      videos {
        id
        verse_video_id
      }
      experts {
        id
        name
        avatar
        job_title
        slug
      }
      pathways {
        id
        name
        slug
        image_url
        duration
        count_videos
        difficulty {
          id
          title
        }
        quizes {
          id
        }
        available_quizes {
          id
        }
        videos {
          video_url
        }
      }
      about_course
      key_learning_objectives {
        id
        title
      }
      who_is_this_for
      requirements
      experts {
        id
        avatar
        job_title
        name
        slug
      }
      partners {
        alt
        image_url
      }
    }
  }
`;

export const GET_COURSE_PROGRESS = gql`
  query GetCourseProgress($filter: CourseSearchFilter) {
    getCourse(filter: $filter) {
      # hash work only for authenticated user
      hash
      progress
      status
    }
  }
`;

export const START_COURSE = gql`
  mutation startCourse($course_id: Int!) {
    startCourse(course_id: $course_id)
  }
`;

export const GET_COURSE_PATHWAYS_PROGRESS = gql`
  query GetCoursePathwaysProgress($filter: CourseSearchFilter) {
    getUserCoursePathwaysProgressStat(filter: $filter) {
      cpd_credits_stat {
        completed
        total
      }
      pathways_stat {
        completed
        total
      }
      pathways_progresses_stat {
        progress
        pathway_videos_count
        pathway_watched_videos_count
        test_score
        status
        pathway {
          id
        }
      }
    }
  }
`;

export const GET_COURSE_DATA_BY_HASH = gql`
  query GetCourseDataByHash($hash: String!) {
    getCourseStatusByHash(hash: $hash) {
      course {
        name
        description
        slug
      }
    }
  }
`;

export const GET_COURSE_COMPLETION_BY_HASH = gql`
  query GetCourseCompletionByHash($hash: String!) {
    getCourseStatusByHash(hash: $hash) {
      completed_at
    }
  }
`;
